import { render, staticRenderFns } from "./major.vue?vue&type=template&id=b25dcdd2&scoped=true"
import script from "./major.vue?vue&type=script&lang=js"
export * from "./major.vue?vue&type=script&lang=js"
import style0 from "./major.vue?vue&type=style&index=0&id=b25dcdd2&prod&scoped=true&lang=less"
import style1 from "./major.vue?vue&type=style&index=1&id=b25dcdd2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b25dcdd2",
  null
  
)

export default component.exports